<template>
  <div>

    <dialog-edit-main-data></dialog-edit-main-data>

    <v-form readonly>
      <v-row>
        <v-col>
          <v-text-field prepend-icon="mdi-information" :value="main_data.name" label="Nome" type="text"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field prepend-icon="mdi-card-bulleted" :value="main_data.corporate_name" label="Razão Social" type="text"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field prepend-icon="mdi-card-bulleted-outline" :value="main_data.document" label="CNPJ" v-mask="'##.###.###/####-##'"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-textarea label="Comentário" :value="main_data.comment"></v-textarea>
        </v-col>
      </v-row>
    </v-form>

    <v-container class="d-flex justify-center">
      <v-btn disabled color="primary">Mostrar Documento</v-btn>
    </v-container>
  </div>
</template>

<script>

  export default {
    name: 'ShowMainData',
    components: {
      DialogEditMainData: () => import('../register/edit/DialogEditMainData'),
    },
    props: {
        main_data: {
            type: Object
        }
    },
    data() {
      return {

      }
    },
    methods: {
    },
    computed: {
    },
    watch: {
    },
  }
</script>

<style lang="scss" scoped>

</style>
